<template>
  <button @click="params.callback(params.data.name)" class="btn">
    <i class="fal fa-trash"></i>
  </button>
</template>
